import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import * as types from './types';
export default {
  updateTcVars(_ref, newTcVars) {
    var {
      commit
    } = _ref;
    commit(types.SET_TC_VARIABLES, newTcVars);
  },

  resetTcVars(_ref2) {
    var {
      commit
    } = _ref2;
    commit(types.RESET_TC_VARIABLES);
  },

  updateTcListProducts(_ref3, newListProducts) {
    var {
      commit,
      rootGetters
    } = _ref3;
    var productsPerPage = rootGetters['category/productsPerPage'];
    var currentPage = rootGetters['routeNavigation/currentPage'];
    var previousPage = rootGetters['routeNavigation/previousPage'];
    var numberOfPages = newListProducts.length < productsPerPage ? 1 : Math.ceil(newListProducts.length / productsPerPage);
    var minIdxAccepted = numberOfPages * productsPerPage - productsPerPage;
    var listProducts = newListProducts.reduce((acc, p, idx) => {
      var lastProductsInPage = currentPage >= previousPage && idx + 1 > minIdxAccepted;
      var firstProductsInPage = currentPage < previousPage && idx + 1 <= productsPerPage;
      if (lastProductsInPage || firstProductsInPage) acc.push({
        list_product_id: p.reference,
        list_product_position: idx + 1
      });
      return acc;
    }, []);
    commit(types.SET_TC_VARIABLES, {
      page_number: numberOfPages,
      list_products: listProducts
    });
  },

  sendTcVars(_ref4, newTcVars) {
    var {
      dispatch,
      rootGetters
    } = _ref4;
    dispatch('updateTcVars', newTcVars);
    var tcVars = rootGetters['analytics/tcVariables'];
    if (process.client && 'init' in window.LUX) window.LUX.init();

    if (process.client && Object.keys(tcVars).length) {
      window.tc_vars = tcVars;
      var debugging = process.client && this.app.$cookies.get('debugmdm');
      if (debugging) console.info('[tagCo] tc_vars :', tcVars);

      if (window.tC) {
        window.tC.container.reload();
        window.tC.event.reload();
        if (debugging) console.info('[tagCo] reload completed');
      }
    }
  }

};